import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { User } from "lucide-react";
import { CarrierFormData } from "./CarrierSignup";

interface Props {
  handleInputChange: (field: keyof CarrierFormData, value: any) => void;
  formData: CarrierFormData;
}

export function PrimaryContactCard({ handleInputChange, formData }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <User className="h-5 w-5" />
          Primary Contact
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="primaryContactName">Contact Name *</Label>
          <Input
            id="primaryContactName"
            value={formData.primaryContactName}
            onChange={(e) =>
              handleInputChange("primaryContactName", e.target.value)
            }
            placeholder="John Smith"
          />
        </div>
        <div>
          <Label htmlFor="primaryContactTitle">Title *</Label>
          <Input
            id="primaryContactTitle"
            value={formData.primaryContactTitle}
            onChange={(e) =>
              handleInputChange("primaryContactTitle", e.target.value)
            }
            placeholder="Fleet Manager"
          />
        </div>
        <div>
          <Label htmlFor="primaryContactPhone">Phone Number *</Label>
          <Input
            id="primaryContactPhone"
            value={formData.primaryContactPhone}
            onChange={(e) =>
              handleInputChange("primaryContactPhone", e.target.value)
            }
            placeholder="(555) 123-4567"
          />
        </div>
        <div>
          <Label htmlFor="primaryContactEmail">Email Address *</Label>
          <Input
            id="primaryContactEmail"
            type="email"
            value={formData.primaryContactEmail}
            onChange={(e) =>
              handleInputChange("primaryContactEmail", e.target.value)
            }
            placeholder="john@company.com"
          />
        </div>
      </CardContent>
    </Card>
  );
}
